import { ofType } from 'redux-observable';
import { debounceTime, switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import {
  SEARCH_INVENTORY,
  INFINITE_SUCCESS,
  EPIC_ERROR,
} from 'Constants/redux';
import service from 'Api/service';

const fetchInfiniteInventoryEpic = (action$) =>
  action$.pipe(
    ofType(SEARCH_INVENTORY),
    debounceTime(500),
    switchMap((action) =>
      from(
        service.post(
          `${import.meta.env.VITE_API_DOMAIN}${action.link}`,
          action.options
        )
      ).pipe(
        map((response) => ({
          type: INFINITE_SUCCESS,
          link: action.link,
          options: action.options,
          reset: true,
          response,
          productType: action.productType,
        })),
        catchError((error) => {
          console.error('fetchInfiniteInventoryEpic error', error);
          return of({ type: EPIC_ERROR });
        })
      )
    )
  );

export default fetchInfiniteInventoryEpic;
